/** @module Apparel/PrintDesign/AggregateColorSpecController */
define([
	"dojo/_base/declare",
	"csi/heading/_AggregateWithNewMixin",
	"csi/heading/AggregateController",
	"csi/locale"
], function(declare,_AggregateWithNewMixin,AggregateController,locale) {

	return declare([AggregateController,_AggregateWithNewMixin], {
		aggregateNewNodeType: "ColorSpecification",

		/**
		 * Allow custom error handling for New action
		 * @param {Controller} ac
		 * @param {Exception} err
		 */
		onNewError: function(ac, err) {
			if (err.csiErrorException && err.csiErrorException.includes("No edit access")) {
				ac.m_error = locale.resource("AggregatePrintPositionColorSpecEditAccess_Error");
				ac._errorCode = "";
			}
		}
    });
});